<script lang="ts">
	import { readable } from 'svelte/store';
	import type { WishlistDrawerContent as WishlistDrawerContentComponent } from './WishlistDrawerContent';
	import { getWishlistContext } from '#lib/features/wishlist/utils/getWishlistContext/index.js';
	import { loadWishlistDrawerContent } from '#lib/features/wishlist/utils/loadWishlistDrawerContent/loadWishlistDrawerContent.js';
	import { Drawer } from '$global/components/Drawer';

	const wishlistCtx = getWishlistContext();
	const open = wishlistCtx?.wishlistDrawer.states.open ?? readable(false);

	// Loaded on first open; the nav icon prefetches it and waits for it before
	// opening, so the drawer normally slides in with its content already there.
	let WishlistDrawerContent = $state<typeof WishlistDrawerContentComponent>();

	$effect(() => {
		if ($open && !WishlistDrawerContent) {
			loadWishlistDrawerContent()
				.then((component) => {
					WishlistDrawerContent = component;
				})
				.catch(() => {
					// Retried on the next open.
				});
		}
	});
</script>

{#if wishlistCtx}
	<Drawer
		dataCy="wishlist"
		drawerStores={wishlistCtx.wishlistDrawer}
		class="max-w-[31.25rem]"
	>
		{#if WishlistDrawerContent}
			<WishlistDrawerContent />
		{/if}
	</Drawer>
{/if}
